import React, { Component, Suspense } from "react";
import { BrowserRouter, Route,Routes  } from 'react-router-dom'

import ScrollToTop from "./scrollToTop";
const Header = React.lazy(() => import("./../layout/Header"));
const Footer = React.lazy(() => import("./../layout/Footer"));
const Home   = React.lazy(() => import("./../pages/home/index")); 
const About  = React.lazy(() => import("./../pages/aboutus"));
const RefundPolicy  = React.lazy(() => import("./../pages/refundPolicy")); 
const PrivacyPolicy  = React.lazy(() => import("./../pages/privacyPolicy"));
const TermsAndCondition  = React.lazy(() => import("./../pages/termsAndCondition")); 
const Login = React.lazy(() => import("./../pages/login")); 
const MyAccount = React.lazy(() => import("../pages/myaccount"));
const UpdateProfile = React.lazy(() => import("../pages/updateProfile")); 




const PageNotFound = React.lazy(() => import("./../pages/pageNotFound"));



export default class MyRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_system_error: true,
    };
  }

  render() {
    return (
      <Suspense >
      <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
           <Route exact path="/" element={<Home />}></Route>
                        <Route exact path="/about-us" element={<About />}></Route> 
                        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route exact path="/terms-and-condition" element={<TermsAndCondition />} /> 
                        <Route exact path="/refund-policy" element={<RefundPolicy />} />
                        <Route exact path="/login" element={<Login />} />
                        <Route exact path="/my-account" element={<MyAccount />} />
                        <Route exact path="/account" element={<UpdateProfile />} />
                        <Route path="*" element={<PageNotFound />} />
                    </Routes>
                    <Footer />
      </BrowserRouter>
      </Suspense> 
    );
  }
}
